<div class="pagination-custom-bootstrap" *ngIf="pageCount > 1">
  <nav>
    <ul class="pagination">
      <li class="page-item">
        <button class="page-link"
          [matTooltip]="'pagination.First page' | translate"
          [disabled]='pageIndex == 0'
          (click)="page.emit(pageIndex = 0)">
          <span class="material-icons">
            {{lang == 'en' ? 'first_page' : 'last_page'}}
          </span>
        </button>
      </li>
      <li class="page-item mr-3">
        <button class="page-link"
          [matTooltip]="'pagination.Previous' | translate"
          [disabled]='pageIndex == 0'
          (click)="page.emit(pageIndex - 1)">
          <span class="material-icons">
            {{lang == 'en' ? 'navigate_before' : 'navigate_next'}}
          </span>
        </button>
      </li>

      <li class="page-item" *ngIf="startPage > 0">
        ...
      </li>
      <li class="page-item" *ngFor="let i of pages">
        <button class="page-link" (click)="page.emit(i)" [class.active]='pageIndex == i'>
          {{i + 1}}
        </button>
      </li>
      <li class="page-item" *ngIf="pageCount > endPage">
        ...
      </li>

      <li class="page-item ml-3">
        <button class="page-link"
          [matTooltip]="'pagination.Next' | translate"
          [disabled]='pageIndex == (pageCount - 1)'
          (click)="page.emit(pageIndex + 1)">
          <span class="material-icons">
            {{lang == 'en' ? 'navigate_next' : 'navigate_before'}}
          </span>
        </button>
      </li>
      <li class="page-item">
        <button class="page-link"
          [matTooltip]="'pagination.Last page' | translate"
          [disabled]='pageIndex == (pageCount - 1)'
          (click)="page.emit(pageCount - 1)">
          <span class="material-icons">
            {{lang == 'en' ? 'last_page' : 'first_page'}}
          </span>
        </button>
      </li>

    </ul>
  </nav>
</div>
